import { usePlatform } from '../composables/usePlatform'
import { authenticatedApiCall } from '@/api/authenticatedApiCall'
import { ref } from 'vue'

const banners = ref(null)

export const useBanners = () => {
  const { platform, isPhone } = usePlatform()

  async function getBanners () {
    const params = {}

    if (window?.device?.uuid) {
      params.device_uuid = window.device.uuid
    }

    if (isPhone.value) {
      params.v = platform.value === 'ios' ? process.env.VUE_APP_IOS_VERSION_RAW : process.env.VUE_APP_ANDROID_VERSION_RAW
      params.device = platform.value
    } else {
      params.v = process.env.VUE_APP_ANDROID_VERSION_RAW
      params.device = 'browser'
    }

    const response = await authenticatedApiCall({
      url: '/v6/info/banner/',
      params
    })

    if (response.data.status !== 'ok') {
      throw new Error('Failed to fetch banners')
    }

    banners.value = response.data.data
  }

  return {
    getBanners,
    banners
  }
}
